{
  "Check this table after each Boond change: a wrongly classified state skews every count. Out of scope: {{count}} active people (subcontractors, non-assignable, or set aside by the DAR)._one": "Check this table after each Boond change: a wrongly classified state skews every count. Out of scope: {{count}} active person (subcontractor, non-assignable, or set aside by the DAR).",
  "Check this table after each Boond change: a wrongly classified state skews every count. Out of scope: {{count}} active people (subcontractors, non-assignable, or set aside by the DAR)._other": "Check this table after each Boond change: a wrongly classified state skews every count. Out of scope: {{count}} active people (subcontractors, non-assignable, or set aside by the DAR).",
  "Incomplete streams on {{count}} projects_one": "Incomplete streams on {{count}} project",
  "Incomplete streams on {{count}} projects_other": "Incomplete streams on {{count}} projects",
  "Missing statuses on {{count}} projects_one": "Missing statuses on {{count}} project",
  "Missing statuses on {{count}} projects_other": "Missing statuses on {{count}} projects",
  "target: every {{count}} weeks_one": "target: every {{count}} week",
  "target: every {{count}} weeks_other": "target: every {{count}} weeks",
  "{{count}} actions without an owner._one": "{{count}} action without an owner.",
  "{{count}} actions without an owner._other": "{{count}} actions without an owner.",
  "{{count}} activity reports_one": "{{count}} activity report",
  "{{count}} activity reports_other": "{{count}} activity reports",
  "{{count}} alerts to handle_one": "{{count}} alert to handle",
  "{{count}} alerts to handle_other": "{{count}} alerts to handle",
  "{{count}} archived streams_one": "{{count}} archived stream",
  "{{count}} archived streams_other": "{{count}} archived streams",
  "{{count}} assignments ended_one": "{{count}} assignment ended",
  "{{count}} assignments ended_other": "{{count}} assignments ended",
  "{{count}} gaps between the stream and the planning_one": "{{count}} gap between the stream and the planning",
  "{{count}} gaps between the stream and the planning_other": "{{count}} gaps between the stream and the planning",
  "{{count}} late actions._one": "{{count}} late action.",
  "{{count}} late actions._other": "{{count}} late actions.",
  "{{count}} linked repositories_one": "{{count}} linked repository",
  "{{count}} linked repositories_other": "{{count}} linked repositories",
  "{{count}} members_one": "{{count}} member",
  "{{count}} members_other": "{{count}} members",
  "{{count}} missing reports_one": "{{count}} missing report",
  "{{count}} missing reports_other": "{{count}} missing reports",
  "{{count}} more alerts_one": "{{count}} more alert",
  "{{count}} more alerts_other": "{{count}} more alerts",
  "{{count}} other signals_one": "{{count}} other signal",
  "{{count}} other signals_other": "{{count}} other signals",
  "{{count}} people changed status._one": "{{count}} person changed status.",
  "{{count}} people changed status._other": "{{count}} people changed status.",
  "{{count}} people_one": "{{count}} person",
  "{{count}} people_other": "{{count}} people",
  "{{count}} projects_one": "{{count}} project",
  "{{count}} projects_other": "{{count}} projects",
  "{{count}} reminders sent_one": "{{count}} reminder sent",
  "{{count}} reminders sent_other": "{{count}} reminders sent",
  "{{count}} reports_one": "{{count}} report",
  "{{count}} reports_other": "{{count}} reports",
  "{{count}} requests cancelled_one": "{{count}} request cancelled",
  "{{count}} requests cancelled_other": "{{count}} requests cancelled",
  "{{count}} results_one": "{{count}} result",
  "{{count}} results_other": "{{count}} results",
  "{{count}} sections still to file for this week._one": "{{count}} section still to file for this week.",
  "{{count}} sections still to file for this week._other": "{{count}} sections still to file for this week.",
  "{{count}} slots_one": "{{count}} slot",
  "{{count}} slots_other": "{{count}} slots",
  "{{count}} streams: {{list}}_one": "{{count}} stream: {{list}}",
  "{{count}} streams: {{list}}_other": "{{count}} streams: {{list}}",
  "{{count}} streams_one": "{{count}} stream",
  "{{count}} streams_other": "{{count}} streams",
  "{{count}} unclassified job titles_one": "{{count}} unclassified job title",
  "{{count}} unclassified job titles_other": "{{count}} unclassified job titles",
  "{{fte}} FTE · {{count}} people_one": "{{fte}} FTE · {{count}} person",
  "{{fte}} FTE · {{count}} people_other": "{{fte}} FTE · {{count}} people",
  "{{where}} has not been updated for {{count}} days._one": "{{where}} has not been updated for {{count}} day.",
  "{{where}} has not been updated for {{count}} days._other": "{{where}} has not been updated for {{count}} days.",
  "{{where}}: {{count}} streams without a PO and a tech lead._one": "{{where}}: {{count}} stream without a PO and a tech lead.",
  "{{where}}: {{count}} streams without a PO and a tech lead._other": "{{where}}: {{count}} streams without a PO and a tech lead.",
  "{{where}}: {{count}} streams without a status._one": "{{where}}: {{count}} stream without a status.",
  "{{where}}: {{count}} streams without a status._other": "{{where}}: {{count}} streams without a status."
}
